const searchForm = document.querySelector('.site-search')

if (searchForm) {
	const field = searchForm.elements['search']
	const minLength = 2

	const getSuggestionsHTML = (input) => {
		const data = new FormData(searchForm)
		data.append('action', 'get_site_search_HTML')

		fetch(OA_AJAX.ajax_url, {
			method: 'POST',
			body: data
		})
		.then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok')
			}

			return response.json()
		})
		.then(data => {
			const results = searchForm.querySelector('.results')

			results.innerHTML = data.data
		})
		.catch(error => {
			console.error('Error:', error)
		});
	}

	field.addEventListener('input', () => {
		if (field.value.length >= minLength) {
			getSuggestionsHTML(field.value)

		} else {
			const results = searchForm.querySelector('.results')
			results.innerHTML = ''
		}
	})

	searchForm.addEventListener('submit', e => {
		e.preventDefault()
	})
}
